import * as React from 'react';
import { SVGProps } from 'react';

const IconDocFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-5.707-5.707A1 1 0 0 0 13.586 2H6zm8 7a1 1 0 0 1-1-1V3.5L18.5 9H14zm-7 4h10v2H7v-2zm6 3H7v2h6v-2z"
    />
  </svg>
);
export default IconDocFilledSizeM;
